import { hotBoard, statsData } from "@/mocks/gossip";

export default function Hero() {
  return (
    <section id="board" className="scroll-mt-20 border-b border-stone-200/70 bg-[#FFF9F1]">
      <div className="mx-auto w-full max-w-6xl px-4 py-8 md:px-6 md:py-12">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-100 px-3 py-1 text-xs font-medium text-emerald-800">
              <i className="ri-flashlight-line"></i>今日多瓜已打包就位
            </span>
            <h1 className="mt-4 text-2xl font-extrabold leading-snug text-stone-900 md:text-4xl">
              多瓜连吃不跑空
              <br className="md:hidden" />
              <span className="text-orange-500"> 一次点开看全</span>
            </h1>
            <p className="mt-3 text-sm leading-relaxed text-stone-600 md:text-base">
              同类事件汇总成一条条清晰线索——热门截图、聊天记录、相关人物与后续进展按顺序排好，多瓜打包不用挨个主页翻。
            </p>
          </div>

          <div className="flex flex-row items-center gap-5">
            {statsData.map((s, i) => (
              <div key={s.label} className="flex items-center gap-5">
                {i > 0 && <span className="h-8 w-px bg-stone-300/60"></span>}
                <div>
                  <p className="text-xl font-extrabold text-stone-900 md:text-2xl">{s.num}</p>
                  <p className="mt-0.5 text-xs text-stone-500">{s.label}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {hotBoard.map((item) => (
            <article
              key={item.rank}
              className="group relative flex flex-col justify-between overflow-hidden rounded-xl border border-stone-200/80 bg-white p-5 transition-colors hover:border-orange-300"
            >
              <div className="flex items-start justify-between gap-2">
                <span
                  className={`flex h-11 w-11 items-center justify-center rounded-lg text-xl font-black ${
                    item.rank === 1
                      ? "bg-orange-500 text-white"
                      : item.rank === 2
                        ? "bg-orange-200 text-orange-800"
                        : "bg-emerald-100 text-emerald-800"
                  }`}
                >
                  {item.rank}
                </span>
                <span className="inline-flex items-center gap-1 rounded-full bg-stone-100 px-2 py-1 text-xs font-medium text-stone-600">
                  {item.hot === "raise" ? (
                    <i className="text-orange-500 ri-fire-line"></i>
                  ) : item.hot === "new" ? (
                    <i className="text-emerald-500 ri-sparkling-2-line"></i>
                  ) : (
                    <i className="text-stone-400 ri-bar-chart-line"></i>
                  )}
                  <span className="whitespace-nowrap">{item.trend}</span>
                </span>
              </div>

              <div className="mt-4">
                <span className="text-xs font-medium text-stone-400">{item.tag}</span>
                <h2 className="mt-1.5 text-[15px] font-bold leading-snug text-stone-900 group-hover:text-orange-600 md:text-base">
                  {item.title}
                </h2>
                <p className="mt-2 text-sm leading-relaxed text-stone-500 line-clamp-3">{item.summary}</p>
              </div>

              <div className="mt-4 flex items-center justify-between border-t border-stone-200/70 pt-3 text-xs text-stone-400">
                <span>{item.meta}</span>
                <span className="inline-flex items-center gap-1 whitespace-nowrap text-orange-600">
                  看线索 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}